import {unparse} from 'papaparse';
import * as FileSaver from 'file-saver';

export function parseJsonToCsv(json: any): string {
  return unparse(json, {
    quotes: true,
    delimiter: ','
  });
}

export function downloadCsvFile(csv: string, fileName: string): void {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    FileSaver.saveAs(url, `${fileName}.csv`);
}
